<template>
  <div class="hello">
    <br>
    <div class="filter">
      <div class="center">
      <Datepicker v-model="selectedDate" lang="es" placeholder="Seleccionar Fecha" position="center" v-on:update:modelValue="getCallsByDate"  />
      </div>
    </div>

    <h2 ref="label">Listado de llamadas</h2>
    <div class="notfound" v-if="calls.length<=0">
      <img src="~@/assets/no-phone.png">
      <h3>No existen registro de llamadas en la fecha seleccionada</h3>
    </div>

    <ul class="report">
      <li v-for="(call, i) in calls" :key="'call' + i" @click.stop="getRecord(call,$event)">
        <h2>{{call.alias}} <span>{{call.fecha}}</span></h2>
        <div class="meta">
          <p><i data-feather="clock"></i> {{ this.getMinutes(call.duration) }}</p>
        </div>
        <a href="javascript:void(0)" class="btn"> <i data-feather="play"></i></a>
      </li>
    </ul>
  </div>
  <section class="player">
    <a href="javascript:void(0)" class="btn" @click="closePlayer()"><i data-feather="x"></i></a>
    <audio id="player" controls class="player"><source id="mp3_src" src="" type="audio/mpeg"></audio>
  </section>
</template>

<script>
import axios from "axios";
import VueDatepickerUi from 'vue-datepicker-ui'
import 'vue-datepicker-ui/lib/vuedatepickerui.css';
import feather from 'feather-icons';
import {_} from 'vue-underscore';


export default {
  components: {
      Datepicker: VueDatepickerUi
    },
  data: () => ({
    selectedDate: new Date(),
    calls: [],
    assets: [],
    blockCalendar: false,
    elPlayer: null,

  }),
  name: 'GetCalls',
  props: {
    msg: String
  },
  mounted(){

  },

  created() {
  this.getAssets();
  this.blockCalendar = true;

  },
  updated(){
    this.$nextTick(function () {
      feather.replace();
    });
  },
   methods: {
     getCallsByDate(){
      if(this.blockCalendar) return false;
      this.blockCalendar = true;
       let d = this.formatDate(new Date(this.selectedDate));
       this.getCallHistory(d);
       console.log(d);
     },

     padTo2Digits(num) {
       return num.toString().padStart(2, '0');
     },

     formatDate(date) {
      return [date.getFullYear(),this.padTo2Digits(date.getMonth()+1),this.padTo2Digits(date.getDate())].join('-');

    },

     closePlayer(){
      this.elPlayer.classList.remove("active");
      let player = document.getElementById('player');
      player.pause();
      player.currentTime=0;
     },

     getMinutes(time){
      var hrs = ~~(time / 3600);
        var mins = ~~((time % 3600) / 60);
        var secs = ~~time % 60;

        // Output like "1:01" or "4:03:59" or "123:03:59"
        var ret = "";
        if (hrs > 0) {
            ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        }
        ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        ret += "" + secs;
        let label = "min";
        if(secs <60 && mins <1) label = "seg";
        return ret+" "+label;

     },

     getCallHistory(d){
      this.calls = [];
      this.$refs.label.innerHTML = "Listado de llamadas";
      if(d==undefined){
        this.blockCalendar = false;
        return;
      }


      if(new Date(d) > new Date()){
        this.blockCalendar = false;
        return false;
      }

      let qs = {
        access_token: this.vi_token,
        datetime_start: d+' 00:00:00',
        datetime_end: d+' 23:59:59',
        domain: this.vi_dom,
        variables: '{"extension": "100"}',
        limit:50,
        sort:"-",
        timezone: 'America/Monterrey',
      }


      axios.post('https://kitapi-us.voximplant.com/api/v4/history/searchCalls',{ }, {
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
        params: qs,
      }).then((result) => {
        this.blockCalendar = false;
        let temp = result.data.result;
        if(temp.length==0) this.$refs.label.innerHTML = "Listado de llamadas";
        let assignedAssets = [];
        for(var i=0;i<temp.length;i++){

          let remove = 0;
          let call_data = JSON.parse(temp[i].call_data);
          let d= this.convertUTCDateToLocalDate(new Date(temp[i].datetime_start));
          console.log(d+"-"+d.toLocaleDateString('es-MX'));
          temp[i].fecha = d.toLocaleDateString('es-MX')+" "+d.toLocaleTimeString('es-MX');

          temp[i].alias = "ACTIVO SIN NOMBRE";
          let demo = [];
          if(call_data.hasOwnProperty('number')){
            demo = _.findWhere(this.assets, {no:call_data.number.toString() });
          }

          if(demo){
            temp[i].alias = demo.alias;
            assignedAssets.push(temp[i]);
          }

        }
        this.calls = assignedAssets;
      });


     },

    convertUTCDateToLocalDate(date) {
      var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);
      var offset = date.getTimezoneOffset() / 60;
      var hours = date.getHours();
      newDate.setHours(hours - offset);
      return newDate;
    },

     async getAssets(){

     await axios({
        method: 'post',
        url: 'https://evotrack.com.mx/remote/json.list.php',
        headers: { 'content-type': 'application/x-www-form-urlencoded'  },
        data: { cid: this.$root.user.id_client ,uid: this.$root.user.id_user, type: this.$root.user.type },
      }).then((result) => {
        this.assets = result.data.assets;
        this.blockCalendar = false;
        this.getCallsByDate();

      }).catch(function(){ });

     },

     getRecord(item,e){

      this.elPlayer = document.querySelector("section.player");
      this.elPlayer.classList.add("active");

      const boxes = document.querySelectorAll('ul.report li');
      boxes.forEach(box => { box.classList.remove("on"); });
      e.currentTarget.classList.add("on");
      let player = document.getElementById('player');
        player.src = item.record_url.replace("https://storage-gw-us-01.voximplant.com","/vault");
        player.play();
        player.onerror = function(event) {
            console.log(event);
            alert("No se puede reproducir el audio, ha existido un error.")
        }



     },
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* { box-sizing:border-box;}

.filter { padding-top:25px; padding-bottom:15px; text-align: center;}
.filter .center { text-align: center; margin:auto; max-width: 500px;;}

h2 { text-transform: uppercase; color:#fbfbfb; font-size:12px; letter-spacing: 1px; text-align: left; font-weight: bold; text-indent: 5px; margin-bottom:20px; position:relative; text-indent:25px;}
h2 span { position:absolute; right:5px; font-weight: 100; }
ul.report { max-width:100%; margin:auto; padding:0; padding-left:20px; padding-right:20px; padding-bottom:200px;}
ul.report li { box-shadow:0px 0px 14px rgba(0,0,0,.15); width:100%; margin-bottom:20px; border-radius:6px;  display:inline-block; border:#2e323d solid 1px; border-radius:6px; overflow:hidden; color:#cdcdcd; position:relative;}
ul.report li .meta { padding:15px; text-align: left;}
ul.report li .meta p { margin:0; vertical-align: middle;;}
ul.report li .meta svg { width:17px; height: 17px; margin-right: 6px; vertical-align: middle;;}
ul.report li a.btn { background-color:#2e323d; border-radius:100px; width:35px; height:35px; position: absolute; right:10px; top:50px; color:#fff; line-height: 45px; text-align: center;;}
ul.report li a.btn svg { width:20px; height: 20px; color:#00b589; }
ul.report li h2 { background: #2e323d; color:#f7fbfa; font-size:14px; margin:0; padding:12px 10px; text-align:left; text-indent:0; }
ul.report li.on { border:#00b589 solid 2px;}
ul.report li.on h2 { background:#00b589; }

section.player { position: fixed; bottom:-60px; background-color: #00b589; width:100%; padding:25px 25px ;   transition: bottom .200s ease-in; }
section.player.active { bottom:61px;}
section.player audio { border:#ccc solid 2px; border-radius: 100px; box-shadow:0px 0px 10px rgba(0,0,0,.25); width:100%; }

.notfound { max-width:220px; margin:auto; margin-top:100px; }
.notfound img { width:100%; }
.notfound h3 { text-align: center; margin-top:25px; color:#00b589; font-size: 25px; font-weight: 400; }

section.player a.btn {
  width:30px; height:30px; position: absolute;
  top:3px; right:3px; position: absolute;
  color:#fff;
  line-height: 42px;;
  border-radius: 100px;
  opacity:.8;
}

.v-calendar .input-field svg.datepicker { fill: #00b589 !important; }
</style>
